import React from "react";
import { useComplianceFolder } from "../hooks/useComplianceFolder";
import { ADDITIONAL_SLOT_TITLE, folderSearchView } from "../model/complianceRules";
import DocumentSlot from "./DocumentSlot";
import FilePreviewModal from "./FilePreviewModal";
import { folderStyles as styles } from "./complianceStyles";

function FolderSlots({ folderView, actions }) {
    const { expectedRows, additionalDocuments, showAdditionalSlot, showNoResult } = folderView;
    const { busy, uploadFiles, addLink, openDocument, removeDocument, renameDocument } = actions;
    const documentHandlers = { busy, onOpen: openDocument, onDelete: removeDocument, onRename: renameDocument };

    return (
        <div style={styles.slots}>
            {expectedRows.map(({ expected, documents: slotDocuments }) => (
                <DocumentSlot
                    key={expected.key}
                    title={expected.label}
                    documents={slotDocuments}
                    onUpload={files => uploadFiles(files, expected.key)}
                    onAddLink={url => addLink(url, expected.key)}
                    {...documentHandlers}
                />
            ))}
            {showAdditionalSlot && (
                <DocumentSlot
                    title={ADDITIONAL_SLOT_TITLE}
                    documents={additionalDocuments}
                    onUpload={files => uploadFiles(files)}
                    onAddLink={url => addLink(url)}
                    {...documentHandlers}
                    additional
                />
            )}
            {showNoResult && (
                <div style={styles.noResult}>
                    Aucun résultat dans ce bloc
                </div>
            )}
        </div>
    );
}

export default function ComplianceFolder({ folder, nested = false, searchTerm = "" }) {
    const complianceFolder = useComplianceFolder(folder.key);
    const { documents, loading, error, preview, closePreview } = complianceFolder;

    return (
        <section style={styles.section(nested)}>
            <div style={styles.header}>
                {nested ? (
                    <h3 style={styles.nestedTitle}>{folder.label}</h3>
                ) : (
                    <h2 style={styles.title}>{folder.label}</h2>
                )}
            </div>

            <div style={styles.body}>
                {error && <div style={styles.error}>{error}</div>}
                {loading ? (
                    <div style={styles.loading}>Chargement des fichiers...</div>
                ) : (
                    <FolderSlots folderView={folderSearchView(folder, documents, searchTerm)} actions={complianceFolder} />
                )}
                {folder.children?.length > 0 && (
                    <div style={styles.children}>
                        {folder.children.map(child => (
                            <ComplianceFolder key={child.key} folder={child} nested searchTerm={searchTerm} />
                        ))}
                    </div>
                )}
            </div>
            {preview && <FilePreviewModal preview={preview} onClose={closePreview} />}
        </section>
    );
}
